import { Ionicons } from '@expo/vector-icons';
import { useRouter } from 'expo-router';
import React from 'react';
import { Pressable, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { useThemePalette } from '@/config/theme';
import { useLocale } from '@/lib/i18n/LocaleProvider';

import { AppText } from './AppText';

/** Minimal header: back chevron (mirrored in RTL) + optional title + trailing action. */
export function BackHeader({ title, right }: { title?: string; right?: React.ReactNode }) {
  const palette = useThemePalette();
  const router = useRouter();
  const { t } = useTranslation();
  const { isRTL } = useLocale();
  return (
    <View className="flex-row items-center gap-3 px-4 py-3">
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={t('common.back')}
        onPress={() => (router.canGoBack() ? router.back() : router.replace('/'))}
        className="h-9 w-9 items-center justify-center rounded-full bg-surface active:bg-surface-2"
      >
        <Ionicons name={isRTL ? 'chevron-forward' : 'chevron-back'} size={20} color={palette.text} />
      </Pressable>
      {title ? (
        <AppText variant="heading" className="flex-1" numberOfLines={1}>
          {title}
        </AppText>
      ) : (
        <View className="flex-1" />
      )}
      {right ?? null}
    </View>
  );
}
